import { render } from "./P077.vue?vue&type=template&id=52a08696&scoped=true"
import script from "./P077.vue?vue&type=script&lang=js"
export * from "./P077.vue?vue&type=script&lang=js"

import "./P077.vue?vue&type=style&index=0&id=52a08696&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a08696"]])

export default __exports__